<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-10-25 18:40:54
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-15 21:20:01
 * @Description: 
-->
<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose">
    <table-form :dataSource="dataSource" ref="form" :tableData="data" @inputChange="inputChange"></table-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from 'common/components/form/tableForm'
import { gqstep3, zqstep3, step3, step3Agency } from '@/conf/Report-manager'

import {
  saveReportFundInvested,
  updateFundInvestedNew,
  saveReportFundAssets,
  updateFundAssets,
  saveReportMgrProduct,
  updateMgrProduct
} from 'common/js/api'

export default {
  components: {
    TableForm
  },

  props: ['dialogVisible', 'title', 'data', 'codeId', 'chooseFund', 'chooseFundName'],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
      fillType: '',
    }
  },

  mounted() {
    this.setConf()
    console.log('step3Dialog被挂载了')
  },

  methods: {
    async setConf() {
      this.fillType = this.$store.state.ReportData.reportFillType
      console.log('Dialog3 getFillType using', this.fillType)

      if (this.fillType == 'gq') {
        this.dataSource = gqstep3
       
      }
      if (this.fillType == 'zq') {
        this.dataSource = zqstep3
      }
      if (this.fillType == 'x') {
        this.dataSource = step3
      }
      if (this.fillType == 'y') {
        this.dataSource = step3Agency
      }
      this.formData = this.data

      console.log('step3 formData', this.formData)
      console.log('step3 this.dataSource', this.dataSource)
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm()
      if (!isValidate) return false
      let form = this.$refs.form.form
      console.log('底层资产提交表单', form)

      // code id
      form.reportCode = this.codeId
      form.fundId = this.chooseFund
      form.fundName = this.chooseFundName
      //已发行产品必传参数
      if (this.title.includes('编辑')) {
        form.id = this.data.id
        console.log('step 3 资产提交：编辑', form)
        if (this.fillType == 'gq') {
          //   if (this.handleRatio(form.cgRatio)) {
          //     form.cgRatio = (form.cgRatio / 100).toFixed(2);

          await updateFundInvestedNew(form)
          // }
        }
        if (this.fillType == 'zq') {
          // if (
          //   this.handleRatio(form.dzRatio) &&
          //   this.handleRatio(form.aaRatio) &&
          //   this.handleRatio(form.abbbRatio) &&
          //   this.handleRatio(form.bbRatio) &&
          //   this.handleRatio(form.holdcRatio)
          // ) {
          //   form.dzRatio = (form.dzRatio / 100).toFixed(2);

          //   form.aaRatio = (form.aaRatio / 100).toFixed(2);

          //   form.abbbRatio = (form.abbbRatio / 100).toFixed(2);

          //   form.bbRatio = (form.bbRatio / 100).toFixed(2);

          //   form.holdcRatio = (form.holdcRatio / 100).toFixed(2);
          if (element.mgrSelf == '是') {
            element.mgrSelf = 1
          }
          if (element.mgrSelf == '否') {
            element.mgrSelf = 0
          }
          if (element.p2p == '是') {
            element.p2p = 1
          }
          if (element.p2p == '否') {
            element.p2p = 0
          }

          await updateFundAssets(form)
          // }
        }
        if (this.fillType == 'x') {
          console.log('￥￥->update step 3 资产提交x：', form)
          await updateMgrProduct(form)
        }
        if (this.fillType == 'y') {
          console.log('￥￥->update step 3 资产提交y：', form)
          await updateFundInvestedNew(form)
        }
      } else {
        if (this.fillType == 'gq') {
          console.log('step 3 资产提交gq：', form)
          await saveReportFundInvested(form)
        }
        if (this.fillType == 'zq') {
          console.log('step 3 资产提交zq：', form)
          await saveReportFundAssets(form)
        }
        if (this.fillType == 'x') {
          form.productType = 0
          console.log('step 3 资产提交x：', form)
          await saveReportMgrProduct(form)
        }
        if (this.fillType == 'y') {
          //基金机构填写默认的ID
          form.fundId = -1
          //标识已投：1 ---拟投资：0
          form.investedType = 0
          await saveReportFundInvested(form)
        }
      }

      const message = this.title.includes('添加') ? '添加' : '编辑'
      this.$message({
        message: `年内拟发行产品${message}成功!`,
        type: 'success'
      })
      this.$emit('reload')
      this.handleClose()
    },
    handleRatio(data) {
      if (data > 100 || data <= 0) {
        this.$message({
          message: '请先输入正确的比例!',
          type: 'warning'
        })
        return false
      }
      return true
    },
    handleClose() {
      this.formData = {}
      this.dialogFormVisible = false
      this.$emit('closeDialog')
    },
    async inputChange(val) {
      
      this.$emit('inputChange', val)
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue
    }
  }
}
</script>

